export const PenNib = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_102_2240)">
      <path
        d="M10.875 15C11.9105 15 12.75 14.1605 12.75 13.125C12.75 12.0895 11.9105 11.25 10.875 11.25C9.83947 11.25 9 12.0895 9 13.125C9 14.1605 9.83947 15 10.875 15Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00093 21L9.54937 14.4506"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21L16.0734 18.8212C16.2031 18.7995 16.3249 18.7441 16.4264 18.6605C16.5279 18.5769 16.6057 18.4681 16.6519 18.345L18.75 12.75L11.25 5.25L5.655 7.34812C5.53187 7.39432 5.42306 7.47208 5.33947 7.57361C5.25588 7.67514 5.20045 7.79686 5.17875 7.92656L3 21Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 12.75L21.5306 9.96937C21.6712 9.82874 21.7501 9.63804 21.7501 9.43922C21.7501 9.24039 21.6712 9.0497 21.5306 8.90906L15.0938 2.46937C14.9531 2.32883 14.7624 2.24988 14.5636 2.24988C14.3648 2.24988 14.1741 2.32883 14.0334 2.46937L11.25 5.25"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_2240">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
